/**
 * @generated SignedSource<<d7842cc6bff13173533091b936bde02d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type Permission = "AccountPermission_AVGS_IsAVGSAccount" | "AccountPermission_AZAVAdmin_IsAZAVAccount" | "AccountPermission_AccountMemberManagement_CanInviteOrAddUsersToUserInAccountGroups" | "AccountPermission_Auth_IsBusinessAccount" | "AccountPermission_Auth_usePlacement" | "AccountPermission_CoachingCoachProfileAdmin_IsCoachAccount" | "AccountPermission_PotentialAnalysis_IsPotentialAnalysisAccount" | "AccountPermission_System_Root" | "UserInAccountPermission_AVGS_IsAVGSAdmin" | "UserInAccountPermission_AVGS_IsAVGSCoach" | "UserInAccountPermission_AVGS_ModifyAdmin" | "UserInAccountPermission_AVGS_ReadAdmin" | "UserInAccountPermission_AZAVAdmin_Modify" | "UserInAccountPermission_AZAVAdmin_Read" | "UserInAccountPermission_AsyncElementTaskAdmin_Modify" | "UserInAccountPermission_AsyncElementTaskAdmin_Read" | "UserInAccountPermission_AuthAdmin_MinimalRead" | "UserInAccountPermission_AuthAdmin_Modify" | "UserInAccountPermission_AuthAdmin_Read" | "UserInAccountPermission_Auth_Modify" | "UserInAccountPermission_Auth_Read" | "UserInAccountPermission_CachingAdmin_Modify" | "UserInAccountPermission_CoachBillingAdmin_Read" | "UserInAccountPermission_CoachFeedback_Read" | "UserInAccountPermission_CoachingAvailabilityAdmin_ModifyAvailability" | "UserInAccountPermission_CoachingAvailabilityAdmin_ReadAvailability" | "UserInAccountPermission_CoachingCoachProfileAdmin_ModifyCoachProfiles" | "UserInAccountPermission_CoachingCoachProfileAdmin_ReadCoachProfiles" | "UserInAccountPermission_CoachingOfferAdmin_Modify" | "UserInAccountPermission_CoachingOfferAdmin_Read" | "UserInAccountPermission_ContractPartnerAdmin_Modify" | "UserInAccountPermission_ContractPartnerAdmin_Read" | "UserInAccountPermission_CustomerFeedback_Modify" | "UserInAccountPermission_CustomerFeedback_Read" | "UserInAccountPermission_DiscountAdmin_Modify" | "UserInAccountPermission_DiscountAdmin_Read" | "UserInAccountPermission_Email_Templates" | "UserInAccountPermission_ExternalLicenseAdmin_Modify" | "UserInAccountPermission_ExternalLicenseAdmin_Read" | "UserInAccountPermission_FeatureToggleAdmin_Modify" | "UserInAccountPermission_FeatureToggleAdmin_Read" | "UserInAccountPermission_Files_Delete" | "UserInAccountPermission_GenerateCartLinkAdmin_Modify" | "UserInAccountPermission_Instructors_CreateInstructors" | "UserInAccountPermission_Instructors_DeleteInstructors" | "UserInAccountPermission_Instructors_ReadInstructors" | "UserInAccountPermission_Instructors_UpdateInstructors" | "UserInAccountPermission_LearnStates_ReadLearnStates" | "UserInAccountPermission_LearnableAdmin_Modify" | "UserInAccountPermission_LearnableAdmin_Read" | "UserInAccountPermission_LicenseAdmin_Modify" | "UserInAccountPermission_LicenseAdmin_Read" | "UserInAccountPermission_LicenseDefinitionAdmin_Modify" | "UserInAccountPermission_LicenseDefinitionAdmin_Read" | "UserInAccountPermission_LimitedCartDiscountAdmin_Modify" | "UserInAccountPermission_LimitedCartDiscountAdmin_Read" | "UserInAccountPermission_Management_Management" | "UserInAccountPermission_Nodes_CreateNodes" | "UserInAccountPermission_Nodes_DeleteNodes" | "UserInAccountPermission_Nodes_PublishNodes" | "UserInAccountPermission_Nodes_ReadNodes" | "UserInAccountPermission_Nodes_UpdateNodes" | "UserInAccountPermission_OrderAdmin_Modify" | "UserInAccountPermission_OrderAdmin_Read" | "UserInAccountPermission_PlacementContactPerson_Access" | "UserInAccountPermission_PotentialAnalysis_IsPotentialAnalysisAdmin" | "UserInAccountPermission_PotentialAnalysis_IsPotentialAnalysisCoach" | "UserInAccountPermission_PotentialAnalysis_ModifyAdmin" | "UserInAccountPermission_PotentialAnalysis_ReadAdmin" | "UserInAccountPermission_ProductAdmin_Modify" | "UserInAccountPermission_ProductAdmin_Read" | "UserInAccountPermission_ReportAdmin_Modify" | "UserInAccountPermission_ReportAdmin_Read" | "UserInAccountPermission_SettingsAdmin_Modify" | "UserInAccountPermission_SettingsAdmin_Read" | "UserInAccountPermission_Submissions_ReadSubmissions" | "UserInAccountPermission_System_Owner" | "UserInAccountPermission_TagAdmin_Modify" | "UserInAccountPermission_TagAdmin_Read" | "UserInAccountPermission_TagAdmin_Select" | "UserInAccountPermission_Tags_CreateTags" | "UserInAccountPermission_Tags_DeleteTags" | "UserInAccountPermission_Tags_ReadTags" | "UserInAccountPermission_Tags_UpdateTags" | "UserInAccountPermission_TreeStateAdmin_Modify" | "UserInAccountPermission_TreeStateAdmin_Read" | "UserInAccountPermission_TreeUnlockedStateAdmin_Modify" | "UserInAccountPermission_TreeUnlockedStateAdmin_Read" | "UserInAccountPermission_Trend_Modify" | "UserInAccountPermission_Trend_Read" | "UserInAccountPermission_TriggerActionAdmin_Modify" | "UserInAccountPermission_TriggerActionAdmin_Read" | "UserInAccountPermission_V2MigrationAdmin_Convert" | "UserInAccountPermission_VimeoVideoSourceAdmin_Modify" | "UserInAccountPermission_VimeoVideoSourceAdmin_Read" | "UserInAccountPermission_VocabAdmin_ModifyWordPackages" | "UserInAccountPermission_VocabAdmin_ReadWordPackages";
export type useAuthContext_PermissionQuery$variables = {};
export type useAuthContext_PermissionQuery$data = {
  readonly Viewer: {
    readonly Auth: {
      readonly currentUser: {
        readonly permissionsInAccount: ReadonlyArray<Permission>;
        readonly user: {
          readonly id: string;
        };
      } | null;
    };
  };
};
export type useAuthContext_PermissionQuery = {
  response: useAuthContext_PermissionQuery$data;
  variables: useAuthContext_PermissionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ViewerQueryType",
    "kind": "LinkedField",
    "name": "Viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthViewerSchema",
        "kind": "LinkedField",
        "name": "Auth",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CurrentUser",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "permissionsInAccount",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useAuthContext_PermissionQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useAuthContext_PermissionQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "53b35020fd2fc40790fa752704e14de5",
    "id": null,
    "metadata": {},
    "name": "useAuthContext_PermissionQuery",
    "operationKind": "query",
    "text": "query useAuthContext_PermissionQuery {\n  Viewer {\n    Auth {\n      currentUser {\n        user {\n          id\n        }\n        permissionsInAccount\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "11cbbaec3bae81c38c3fe2080f34f109";

export default node;
